import springCenfApi from '../../services/springCenfApi'

export const getWarehouseDocks = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/warehouse_docks', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getWarehouseDock = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/warehouse_docks/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeWarehouseDock = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/warehouse_docks', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateWarehouseDock = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/warehouse_docks/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteWarehouseDock = id => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/warehouse_docks/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)